<template>
   <results-wrapper>
      <el-tabs>
         <el-tab-pane label="SST">
            <div class='sst-clusters'>
               <div class="title">List of SST Clusters</div>
               <!-- key="currentClusters.length" is used to force rerender the vue-editable-grid when displayed data is changed -->
               <!-- it doesn't properly re-render if we don't force it by manually set it to change -->
               <vue-editable-grid
                  ref="table"
                  id="sst-table"
                  class='sst-clusters-table'
                  :key="currentClusters.length"
                  :column-defs="columnDefs"
                  @cell-updated="() =>{}"
                  :row-data="currentClusters"
                  row-data-key="psu_id"
                  :enable-filters="false"
                  :page-count="pageSize"
                  :item-height="35"
               />
               <div class='pagination-footer'>
                  <div class='download-btns'>
                     <a :if="kmlLink" :href="kmlLink" download="clusters.kml"><atom-button size="small">Download KML</atom-button></a>
                  </div>
                  <el-pagination
                     @size-change="handleSizeChange"
                     @current-change='handleCurrentChange'
                     :current-page.sync="currentPage"
                     :page-sizes="[10,20,30,40]"
                     :page-size="pageSize"
                     layout="sizes, prev, pager, next, total"
                     :total="totalClusters.length"
                  ></el-pagination>
               </div>
            </div>
         </el-tab-pane>
      </el-tabs>
   </results-wrapper>
</template>

<script>
import { Tabs,TabPane,Pagination } from 'element-ui';
import ResultsWrapper from '../../../molecules/Home/ResultsWrapper';
import AtomButton from '@/components/atoms/Login/Button';
import { mapGetters } from 'vuex';
import { formatLatLng, latLngToNumber } from '../../../../js/ui-helpers';

export default {
   components: {
      'el-tabs': Tabs,
      'el-tab-pane': TabPane,
      'el-pagination': Pagination,
      AtomButton,
      ResultsWrapper,
   },
   data() 
   {
      const formatter = event => {
         if (event.reverse) {
            // Convert from display to raw
            return event.value && latLngToNumber(event.value);
         }
         // Convert from raw to display
         return formatLatLng(event.value);
      };
      return {
         columnDefs: [
            { field: "psu_id", headerName: "PSU ID",    sortable: true, editable: false, size: "10ch", },
            { field: "x",      headerName: "Longitude", sortable: true, editable: false, size: "1fr", formatter},
            { field: "y",      headerName: "Latitude",  sortable: true, editable: false, size: "1fr", formatter},
         ],
         currentPage: 0,
         pageSize: 10,
      };
   },
   computed: {
      ...mapGetters(["getSstResults"]),
      totalClusters()
      {
         return (this.getSstResults && this.getSstResults.table_data) || [];
      },
      downloadFileName() {
         return this.getSstResults && `${ this.getSstResults.municipality }.kml`;
      },
      kmlLink()
      {
         return this.getSstResults && this.getSstResults.base64_kml;
      },
      currentClusters()
      {
         const pageSize = this.pageSize;
         const startIndex = (this.currentPage-1)*pageSize;
         const endIndex = startIndex + pageSize;
         return this.totalClusters.slice(startIndex, endIndex);
      },
   },
   methods: {
      handleCurrentChange(value)
      {
         this.currentPage=value;
      },
      handleSizeChange(value)
      {
         this.pageSize=value;
      }
   },
};
</script>

<style lang="scss">
.sst-clusters {
   border-radius: 0.25em;
   // padding: 0.5em;
   width: 100%;
   background: white;
   margin: 0.5em;
   * {
      color: $font-color;
   }
   // .el-table_1_column_2 
   > .title {
      font-size: 0.93em;
      padding: 0.8em 1em;
      font-weight: 600;
      border-radius: 0.25em 0.25em 0 0;
      color: $font-color;
      border-bottom: solid 1px rgba($primary-color, 0.1);
   }
   .sst-clusters-table {
      thead tr th,
      td.cell {
         width: 100%;
         display: flex;
         justify-content: center;
         text-align: center;
      }
   }
   .pagination-footer {
      width: 100%;
      padding: 0.1em 1em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .download-btns {
         display: flex;
         > * {
            margin: 0 0.25em;
         }
      }
   }
}
</style>
